import { defineStyleConfig } from "@chakra-ui/react";

export default defineStyleConfig({
  baseStyle: {
    "&:not(.chakra-button)": {
      color: "magenta.veryDark",
      _hover: {
        color: "magenta.dark",
      },
    },
    _hover: {
      textDecoration: "none",
    },
    _disabled: {
      cursor: "default",
      opacity: 0.6,
      pointerEvents: "none",
    },
    "tr[aria-selected=true] &": {
      color: "gray.300",
      _hover: {
        color: "gray.100",
      },
    },
  },
});
